import { AxiosResponse } from 'axios';
import { Objeto } from '../../Models';
import Context from '../../context';

class Lead {
    /* #region  GET Controller  */
    /* Sobre esta função *//**
     * Lista todos os leads cadastrados
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     **/
    public async Get(Token: string): Promise<AxiosResponse<Array<Objeto.Lead>>> {
        return await Context.get(`/Lead/${Token}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* Sobre esta função *//**
     * Lista todos os tipos de dependentes
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     **/
    public async ClassificacaoDoDependente(Token: string): Promise<AxiosResponse<Array<Objeto.Lead>>> {
        return await Context.get(`/Lead/ClassificacaoDoDependente/${Token}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* Sobre esta função *//**
     * Lista todos os tipos de locais de captação
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     **/
    public async LocaisDeCaptacao(Token: string): Promise<AxiosResponse<Array<{ empresa: Objeto.Empresa, locaisDeCaptacao: Array<Object> }>>> {
        return await Context.get(`/Lead/LocaisDeCaptacao/${Token}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  POST Controller  */
    /* Sobre esta função *//**
     * Cadastra um novo lead
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {Objeto.Lead} Lead Informe os dados do lead
     **/
    public async Post(Token: string, Lead: Objeto.Lead): Promise<AxiosResponse<Objeto.Lead>> {
        return await Context.post(`/Lead/${Token}`, Lead)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  DELETE Controller  */
    /* Sobre esta função *//**
     * Deletar o lead
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Id Informe o código do lead (id)
     **/
    public async Delete(Token: string, Id: number): Promise<AxiosResponse<Array<Objeto.Lead>>> {
        return await Context.delete(`/Lead/${Token}/${Id}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  PUT Controller  */
    /* Sobre esta função *//**
     * Altera os dados do lead
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {Objeto.Lead} Lead Informe os dados do lead
     **/
    public async Put(Token: string, Lead: Objeto.Lead): Promise<AxiosResponse<Array<Objeto.Lead>>> {
        return await Context.put(`/Lead/${Token}`, Lead)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */
};

export default new Lead();